import React from 'react';
import styled from 'styled-components';
const IconWrapper = styled.div `
  display: block;
  height: ${(props) => props.size + 5}px;
  width: ${(props) => props.size + 5}px;
`;
const Icon = styled.img `
  display: block;
  padding: 0;
  margin: 0;
  height: ${(props) => props.size}px;
  width: ${(props) => props.size}px;
  border-radius: 50%;
  background-color: #e6e6e6;
  background-size:  cover;
  background-repeat:  no-repeat;
  background-position: center center;
`;
export const SydneyAvatar = (props) => {
    return (React.createElement(IconWrapper, { size: props.size },
        React.createElement(Icon, { size: props.size, src: props.iconUrl, alt: "Sydney Avatar" })));
};
